import PropTypes from 'prop-types';

import style from './MessageDescription.scss';

export const MessageDescription = ({ message }) => (
  <div className={style.MessageDescription} data-testid="MessageDescription">
    {message}
  </div>
);

MessageDescription.propTypes = {
  message: PropTypes.string.isRequired,
};
